// removed by extract-text-webpack-plugin
module.exports = {"share-container":"SocialShareButton-module-share-container-HHfCz","shareContainer":"SocialShareButton-module-share-container-HHfCz","share-listing":"SocialShareButton-module-share-listing-2idz1","shareListing":"SocialShareButton-module-share-listing-2idz1","button-share":"SocialShareButton-module-button-share-356P0","buttonShare":"SocialShareButton-module-button-share-356P0","btn-icon":"SocialShareButton-module-btn-icon-2bCnz","btnIcon":"SocialShareButton-module-btn-icon-2bCnz","btn-text":"SocialShareButton-module-btn-text-35sbF","btnText":"SocialShareButton-module-btn-text-35sbF"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SocialShareButton/SocialShareButton.module.scss
// module id = 1187
// module chunks = 0